<template>
  <!-- 图片 轮播 跟读 -->
  <div class="picture-after-reading">
    <div class="picture-list">
      <ul>
        <li
          @click="chooseImg(item, index, (currentPage - 1) * 4 + index)"
          v-for="(item, index) in imgData"
          :key="index"
          :class="{ cur: index == choose, willRead: index == choose + 1 }"
        >
          <em class="icon-diantufasheng color-base" v-if="index == choose"></em>
          <img :src="item.medias_smallimg" alt />
          <audio
            :src="item.medias_audio"
            :autoplay="choose == index"
            ref="audio"
            @ended="handleEnded"
            @play="handlePlay"
          ></audio>
        </li>
      </ul>
      <div class="arrow-list">
        <span
          v-if="currentPage > 1"
          @click="viewPrev"
          class="arrow icon-shangyiye"
        ></span>
        <span
          v-else
          class="arrow icon-shangyiye"
          :class="{ disabled: currentPage == 1 }"
        ></span>

        <span
          v-if="listData.medias.length > currentPage * 4"
          @click="viewNext"
          class="arrow icon-xiayiye"
        ></span>
        <span v-else class="arrow icon-xiayiye disabled"></span>
      </div>
    </div>
    <div class="picture-show">
      <img :src="chooseUrl" alt />
      <p class="read-progress-tips">
        {{ $t("blendType.alread") }} {{ tempIndex }}/{{
          listData.medias.length
        }}
      </p>
    </div>
    <!-- <Message message="哈哈" :showTip="true"></Message> -->
  </div>
</template>
<script>
// import Message from '../../Common/message.vue'

export default {
  name: "PictureAfterReading",
  props: ["listData"],
  data() {
    return {
      isOn: 0,
      curViewPage: 0,
      choose: 0,
      chooseUrl: "",
      showList: [],
      imgData: [],
      list: [],
      tempIndex: 1,
      isAudioPlay: true,
      timeDuration: null,
      timeNum: 0,
      currentPage: 1,
      isNextStatus: false,
    };
  },
  components: {
    // Message
  },
  computed: {
    type() {
      return this.listData.steps_category;
    },
  },
  methods: {
    handlePlay() {
      console.log("开始播放", this.tempIndex);
      this.isAudioPlay = false;
    },
    handleEnded() {
      console.log("播放结束");
      if (this.listData.medias.length > 4) {
        if (this.isNextStatus) {
          if (this.tempIndex == this.listData.medias.length) {
            console.log("最后一个播放");
            this.$emit("changeType", {
              issucceed: 1,
              operatetime: this.timeNum,
            });
            window.clearInterval(this.timeDuration);
          }
        }
      } else {
        if (this.tempIndex == this.listData.medias.length) {
          console.log("最后一个播放");
          this.$emit("changeType", { issucceed: 1, operatetime: this.timeNum });
          window.clearInterval(this.timeDuration);
        }
      }
      this.isAudioPlay = true;
    },
    chooseImg(item, v, curIndex) {
      console.log('当前播放：', item, v);
      console.log("当前下标(所有音频): ", curIndex);
      console.log("当前已读: ", this.tempIndex);
      if (this.isAudioPlay) {
        console.log(curIndex, this.tempIndex, 'curIndex == this.tempIndex');
        if (curIndex == this.tempIndex) {
          this.chooseUrl = item.medias_bigimg;
          this.choose = v;
          console.log(this.$refs.audio);
          this.$refs.audio.forEach((item, index) => {
            if (item.autoplay == true) {
              console.log(item, index);
              this.$refs.audio[index + 1].play();
            }
          });

          // if (v == this.imgData.length - 1) {
          //   this.$emit("changeType", 4);
          // }
          this.tempIndex++;
        } else {
          if (v + 1 != this.tempIndex && this.tempIndex > v + 1) {
            console.log(this.currentPage, v, 'this.currentPage, v')
            
            this.chooseUrl = item.medias_bigimg;
            this.choose = v;
            this.tempIndex = (this.currentPage - 1) * 4 + v + 1
            this.$refs.audio.forEach((item, index) => {
              if (item.autoplay == true) {
                this.$refs.audio[v].play();
              }
            });
          }
        }
      }
    },
    viewNext() {
      if (this.tempIndex % 4 == 0 && this.isAudioPlay) {
        if (this.listData.medias.length > this.currentPage * 4) {
          ++this.currentPage;
          ++this.tempIndex;
          this.imgData = this.listData.medias.slice(
            (this.currentPage - 1) * 4,
            this.currentPage * 4
          );
          console.log(this.tempIndex);
          this.isNextStatus = true;
          this.choose = 0;
          this.chooseImg(this.imgData[0], 0, this.tempIndex);
        }
      } else {
        console.log("budengyu4");
      }
    },
    viewPrev() {
      if (
        this.listData.medias.length > 4 &&
        this.isNextStatus &&
        this.isAudioPlay &&
        this.tempIndex % 4 == 1
      ) {
        this.tempIndex = this.tempIndex - 2;
        --this.currentPage;
        this.imgData = this.listData.medias.slice(
          (this.currentPage - 1) * 4,
          4 * this.currentPage
        );
        this.isNextStatus = false;
        this.choose = 3;
        this.chooseImg(this.imgData[3], 3, this.tempIndex);
        console.log(this.choose, this.tempIndex);
      }
    },
  },
  created() {
    this.timeDuration = setInterval(() => {
      ++this.timeNum;
    }, 1000);
    // this.showList = this.list.slice(0, 4);
    this.chooseUrl = this.listData.medias[0].medias_bigimg;
  },
  mounted() {
    console.log(this.listData, "listDatalistData");
    this.imgData = [].concat(this.listData.medias);
    if (this.imgData.length > 4) {
      this.imgData = this.imgData.slice((this.currentPage - 1) * 4, 4);
    }
  },
};
</script>

<style lang="less">
.picture-show {
  // max-height: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    display: block;
    min-width: 370px;
    min-height: 420px;
  }
  .read-progress-tips {
    padding-top: 30px;
    font-size: 16px;
    color: rgba(24, 24, 24, 1);
    line-height: 22px;
  }
}
</style>